import { Flex, notify, Spacing, Switch, Text } from '@billy/design-system'
import { ChangeEvent, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useUpdatePayNowActiveStatus } from '@features/paynow/hooks/useUpdatePayNowActiveStatus'

import { NotificationKeys } from '../../../../../../../../enums/notificationKeys'

interface EnableCardPaymentProps {
  isActive: boolean
  isConnected: boolean
}

export const EnableCardPayment = ({ isActive, isConnected }: EnableCardPaymentProps): ReactElement => {
  const { t } = useTranslation()
  const { isProcessing, updatePayNowActiveStatus } = useUpdatePayNowActiveStatus()

  const label = t('settings.organization.card_payments.configuration.allow_card.label')
  const caption =
    isConnected && isActive
      ? t('settings.organization.card_payments.configuration.allow_card.caption')
      : t('settings.organization.card_payments.configuration.allow_card.disconnected.caption')

  const handleToggle = (event: ChangeEvent<HTMLInputElement>) => {
    updatePayNowActiveStatus(
      { active: event.currentTarget.checked },
      {
        onError: () => {
          notify({
            id: NotificationKeys.PayNowStatusUpdateError,
            message: t('settings.organization.card_payments.configuration.allow_card.update_error'),
            variant: 'error',
          })
        },
      },
    )
  }

  return (
    <Flex flexDirection="column" gap={Spacing.S4}>
      <Flex alignItems="center" gap={Spacing.S16}>
        <Text colorVariant={isConnected ? undefined : 'disable'} weight="medium">
          {label}
        </Text>
        <Switch
          aria-label={label}
          checked={isConnected && isActive}
          disabled={!isConnected || isProcessing}
          onChange={handleToggle}
        />
      </Flex>
      <Text colorVariant={isConnected ? 'secondary' : 'disable'} variant="bodySM">
        {caption}
      </Text>
    </Flex>
  )
}
